import { renderFatalError } from "./lib/renderFatalError";
import "./index.css";

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof import("@tanstack/react-router").createRouter>;
  }
}

bootstrap().catch(renderFatalError);

async function bootstrap() {
  const [
    { StrictMode },
    { createRoot },
    { ConvexAuthProvider },
    { RouterProvider, createRouter, Navigate },
    { convex },
    { routeTree },
    { LanguageProvider },
    { AppErrorBoundary },
    { initSentry },
    { initWebVitals },
  ] = await Promise.all([
    import("react"),
    import("react-dom/client"),
    import("@convex-dev/auth/react"),
    import("@tanstack/react-router"),
    import("./lib/convex"),
    import("./routeTree.gen"),
    import("./i18n/LanguageProvider"),
    import("./components/AppErrorBoundary"),
    import("./lib/sentry"),
    import("./lib/vitals"),
  ]);

  await import("./i18n");

  initSentry();
  initWebVitals();

  const router = createRouter({
    routeTree,
    context: {},
    defaultNotFoundComponent: () => <Navigate to="/" />,
  });

  createRoot(document.getElementById("root")!).render(
    <StrictMode>
      <AppErrorBoundary>
        <ConvexAuthProvider client={convex}>
          <LanguageProvider>
            <RouterProvider router={router} />
          </LanguageProvider>
        </ConvexAuthProvider>
      </AppErrorBoundary>
    </StrictMode>
  );
}
